import { BehaviorSubject } from 'rxjs';

import { UiService } from './services/ui.services';

export abstract class BaseStore<TState, TItem> {
  ui: UiService;

  constructor(uiService: UiService, protected stateInit: TState, protected itemInit: TItem) {
    this.ui = uiService;
  }

  protected _state: BehaviorSubject<TState> = new BehaviorSubject(this.stateInit);
  get state$() {
    return this._state.asObservable();
  }

  protected _current: BehaviorSubject<TItem> = new BehaviorSubject(this.itemInit);
  get current$() {
    return this._current.asObservable();
  }
  get current() {
    return this._current.value;
  }
  updateCurrent(model: TItem) {
    this._current.next(model);
  }

  showValidationMessage(message: string) {
    this.ui.alert
      .config({
        type: 'info',
        title: 'Validação',
        buttonOkLabel: 'Ok',
        buttonCancelHidden: true,
        children: () => <span>{message}</span>,
      })
      .open();
  }
}
